// Modul General – i18n manifest (sdílené komponenty nad daty bounded contextu AddressBook)

import type { SliceI18nManifest } from '@/shared/lib/vsa';
import cs from './locales/cs.json';
import en from './locales/en.json';

const NS = 'general';

export const generalI18nManifest: SliceI18nManifest = {
  owner: 'modules/general',
  namespaces: [NS],
  resources: {
    cs: { [NS]: cs },
    en: { [NS]: en },
  },
};
